import request from '@/utils/request';

// 授权登录注册
export function thirdLogin(params) {
  return request({
    url: '/auth/front/h5/login',
    method: 'get',
    params
  });
}

// 兑换
export function exchange(data) {
  return request({
    url: '/activity/front/mkh/exchange/course',
    method: 'post',
    data
  });
}

// 兑换列表
export function courseList(data) {
  return request({
    url: '/course/front/course/mkh/exchange/course/list',
    method: 'post',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/exchange/index.js